export const SET_UPSALE_POPUP_OPEN = "SET_UPSALE_POPUP_OPEN";

export const setUpsalePopupOpen = (value) => ({
    type: SET_UPSALE_POPUP_OPEN,
    payload: value,
});
